import React from 'react'

import { Element } from '@Components/Elements/Types'
import { Button, ButtonProps } from '@CoreComponents/Buttons/Button'
import { getLinkFromReference, parseExtraColors } from '@Globals/CMS/FieldHelpers'

export const ElementButton = ({
  appearance,
  disableLinks = false,
  reference,
  style,
  text,
}: Extract<Element, { __typename: 'ElementButton' }> & {
  disableLinks?: boolean
}) => {
  const extraColors = parseExtraColors(appearance?.extraColors, ['border'])
  const link = getLinkFromReference(reference)

  return (
    <Button
      analytics={!disableLinks
        ? {
          dest_page_type: link?.type,
          dest_page_type_id: link?.id || '',
        }
        : undefined}
      href={!disableLinks ? (link?.url || undefined) : undefined}
      style={{
        backgroundColor: appearance?.backgroundColor || undefined,
        borderColor: extraColors.border || undefined,
        color: appearance?.textColor || undefined,
        fontFamily: `var(--font-${appearance?.font || 'gotham'})`,
      }}
      theme={(style || 'black') as ButtonProps['theme']}
      type="button"
    >
      {text || link?.text || ''}
    </Button>
  )
}
